var $ = jQuery;

function slidingNavInit() {
  //if there's a trigger and a sliding-menu div in the DOM
  if($('.sliding-nav-trigger').length && $('.sliding-nav').length) {
    //add the class to the body and append a cover div
    var $darkCover = $('<div class="dark-cover"></div>');
    $('body').addClass('_has-sliding-nav');
    $('.sliding-nav').after($darkCover);

    $('.sliding-nav-trigger').on('click', function(event) {
      slidingMenuToggle(event);
    });
  }
}

function slidingMenuToggle(event) {
  event.preventDefault();
  $('body').toggleClass('_sliding-nav-showing');
  //unfocus on the hamburger button when opening menu
  if ($('body').hasClass('_sliding-nav-showing')) {
    $('.sliding-nav-section:first a:first').focus();
  }
}

export { slidingNavInit };



